/**
 * Formats a number for display with space separators
 * @param value - The value to format (can be any type)
 * @returns Formatted string or "-" if invalid
 */
export const displayNumber = (value: any): string =>
  (value || value === 0) ? `${value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")}` : "-";

/**
 * Formats a price value for display
 * @param value - The price value to format
 * @returns Formatted price string with CHF prefix or "-" if invalid
 */
export const displayPrice = (value: any): string =>
  value
    ? `CHF ${Math.floor(value)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, " ")}`
    : "-";
